(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("create-es6-js"));
	else if(typeof define === 'function' && define.amd)
		define(["create-es6-js"], factory);
	else if(typeof exports === 'object')
		exports["evolve-js"] = factory(require("create-es6-js"));
	else
		root["evolve-js"] = factory(root["create-es6-js"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition